import React, { useContext } from "react";
import ConfigurationContext from "../../Context/ConfigurationContext";
import CustomizedFilterBar from "../Common/CustomizedFilterBar";
import OccupancyRateContext from "../../Context/Reports/OccupancyRateContext";

const OccupancyRateFilter = () => {

 
    const { locationList, streetList } = useContext(ConfigurationContext);

    const { filterData, getVehicleOccupancyRate } = useContext(OccupancyRateContext)


    const listOptions = [];
    const locationOptions = [];

    Array.isArray(streetList) && streetList.map((item, key) =>
        listOptions.push({
            title: item.street_name,
            value: item.street_id
        })
    );

    Array.isArray(locationList) && locationList.map((item, key) =>
        locationOptions.push({
            title: item.location_name,
            value: item.location_id
        })
    );

    return (
        <CustomizedFilterBar
            // selection={{ title: 'Street', options: listOptions }}
            // selection6={{ title6: 'Location', options6: locationOptions }}
            onReset={()=>getVehicleOccupancyRate({})}
            onConfirm={filterData}
        />
    )
}


export default OccupancyRateFilter;